"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.useButtonContext = exports.ButtonProvider = void 0;
var react_1 = __importStar(require("react"));
var ButtonContext = react_1.createContext({ variant: 'primary', size: 'default' });
var ButtonProvider = function (_a) {
    var _b = _a.variant, variant = _b === void 0 ? 'primary' : _b, _c = _a.size, size = _c === void 0 ? 'default' : _c, _d = _a.disabled, disabled = _d === void 0 ? false : _d, _e = _a.destructive, destructive = _e === void 0 ? false : _e, children = _a.children;
    var contextValue = react_1.useMemo(function () { return ({ variant: variant, size: size, disabled: disabled, destructive: destructive }); }, [variant, size, disabled, destructive]);
    return (react_1.default.createElement(ButtonContext.Provider, { value: contextValue }, children));
};
exports.ButtonProvider = ButtonProvider;
var useButtonContext = function () { return react_1.useContext(ButtonContext); };
exports.useButtonContext = useButtonContext;
